import { cacheDom } from "../utils/QuerySelectors.js"

const dom = {}
const qs = {
  section: 'data-section-type="main-blog"',
  list: 'data-blog-list',
}
const qsAll = {
  quickTags: 'data-article-tag',
}

const getResults = () => {
  const activeTags = dom.quickTags.filter(tag => tag.classList.contains('button--primary__filled'))
    .map(tag => tag.getAttribute(`${qsAll.quickTags}`))
  
  const fetchUrl = `${dom.section.dataset.path}${activeTags.length > 0 ? '/tagged/' + activeTags.join('+') : ''}`
  history.pushState({}, "", fetchUrl)

  fetch(`${fetchUrl}?section_id=${dom.section.dataset.sectionId}`)
  .then(response => response.text())
  .then((text) => {
    const resultsList = new DOMParser().parseFromString(text, 'text/html').querySelector(`[${qs.list}]`).innerHTML
    dom.list.innerHTML = resultsList
  })
  .catch((error) => {
    throw error
  })
}

export const setupBlog = () => {
  cacheDom(dom, qs, qsAll)
  if(dom.section) {
    dom.quickTags.forEach(quickTag => {
      quickTag.addEventListener('click', (e) => {
        e.stopPropagation()
        quickTag.classList.toggle('button--primary')
        quickTag.classList.toggle('button--primary__filled')
        
        dom.quickTags.forEach(tag => {
          if(tag != quickTag) {
            tag.classList.add('button--primary')
            tag.classList.remove('button--primary__filled')
          }
        })

        getResults()
      })
    })
  }
}